import { RAW_cssValue, ThemeUIStyleObject } from "@classdojo/web/nessie/stylingLib";
import { AT } from "@web-monorepo/vite-auto-translate-plugin/runtime";
import React from "react";
import type { AnyAction } from "redux";
import { appMetadataRandom, chooseRandomStudent, displayStudent } from "src/pods/random";
import { Student } from "src/pods/students";
import AppModal from "src/shared/components/AppModal";
import AppPage from "src/shared/components/AppPage";
import logEvent from "src/utils/logEvent";
import { RandomDisplay } from "./RandomDisplay";

type RandomRemoteProps = {
  mountPoint: string;
  classId: string;
  displayOpen: (path: string, action: AnyAction) => void;
  displayClose: VoidFunction;
  remoteClose: VoidFunction;
  displayStudent: (students: Student[], chosenStudent?: Student) => void;
  previouslyChosenStudents: Student[];
  students: Student[];
  selectedStudent?: Student;
};

type RandomRemoteState = {
  requestedStop: boolean;
};

// eslint-disable-next-line react-prefer-function-component/react-prefer-function-component
export default class RandomRemote extends React.Component<RandomRemoteProps, RandomRemoteState> {
  state = {
    requestedStop: false,
  };

  componentDidMount() {
    if (this.props.students) {
      this.displayRandomStudent(this.props.students);
    }

    logEvent({
      eventName: "random.setup.open",
    });
  }

  componentWillUnmount() {
    logEvent({
      eventName: "random.setup.close",
    });
  }

  render() {
    const { students, selectedStudent, classId, mountPoint } = this.props;

    if (Array.isArray(students) && students.length === 0) {
      return (
        <AppPage {...appMetadataRandom()} classId={classId} mountPoint={mountPoint}>
          <div sx={errorContainerStyle}>
            <AT>Your class doesn't have any students :(</AT>
          </div>
        </AppPage>
      );
    }

    if (mountPoint === "mobile") {
      return (
        <AppPage {...appMetadataRandom()} classId={classId} mountPoint={mountPoint}>
          <AppModal
            {...appMetadataRandom()}
            onRequestHide={() => {
              this.props.displayClose();
              this.props.remoteClose();
            }}
            onRequestStop={() => this.props.displayClose()}
          >
            <article>
              <div sx={displayStyle}>
                <RandomDisplay
                  student={selectedStudent}
                  students={students}
                  displayRandomStudent={this.displayRandomStudent}
                />
              </div>
            </article>
          </AppModal>
        </AppPage>
      );
    }

    return <div />;
  }

  UNSAFE_componentWillReceiveProps(nextProps: RandomRemoteProps) {
    if (!this.props.students && nextProps.students && nextProps.students.length) {
      this.displayRandomStudent(nextProps.students);
    }
  }

  displayRandomStudent = (students: Student[]) => {
    if (students.length === 0) return;
    const { previouslyChosenStudents } = this.props;
    const chosenStudent = chooseRandomStudent(students, previouslyChosenStudents);
    this.props.displayStudent(students, chosenStudent);
    this.props.displayOpen("/apps/display/random", displayStudent(students, chosenStudent));
  };
}

const errorContainerStyle: ThemeUIStyleObject = {
  padding: RAW_cssValue(20),
  textAlign: "center",
  fontSize: 16,
};

const displayStyle: ThemeUIStyleObject = {
  padding: RAW_cssValue("20px"),
};
